import { Outlet } from "react-router-dom";
import { CalendarClock, CreditCard, Shirt } from "lucide-react";
import laundryImage from "../assets/image.png";

const HIGHLIGHTS = [
  { icon: Shirt, text: "Drop your bag in a locker or have it collected from home" },
  { icon: CalendarClock, text: "Pick a time slot that suits you" },
  { icon: CreditCard, text: "Review your items, then pay online or on delivery" },
];

/**
 * Sign-in / sign-up pages. Phones: the page as designed. Tablet and up: a
 * brand panel on the left and the page in a centred column on the right.
 */
export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-white md:grid md:grid-cols-2">
      <aside className="hidden md:flex sticky top-0 h-screen flex-col justify-between bg-[#44B6CE] px-12 py-12 text-white">
        <div>
          <img
            src={laundryImage}
            alt="Rush"
            width={170}
            className="object-contain"
            style={{ filter: "brightness(0) invert(1)" }}
          />
          <p className="mt-3 text-white/80">Laundry in minutes</p>
        </div>

        <div className="max-w-sm">
          <h2 className="text-3xl font-bold leading-tight text-white">Clean clothes, without the trip.</h2>
          <ul className="mt-8 space-y-4">
            {HIGHLIGHTS.map((item) => {
              const Icon = item.icon;
              return (
                <li key={item.text} className="flex items-center gap-3">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/20">
                    <Icon className="h-5 w-5" />
                  </span>
                  <span className="text-sm text-white/90">{item.text}</span>
                </li>
              );
            })}
          </ul>
        </div>

        <p className="text-xs text-white/60">© {new Date().getFullYear()} RUSH Laundry</p>
      </aside>

      <div className="md:flex md:min-h-screen md:items-center md:justify-center md:px-8 md:py-10">
        <div className="w-full md:max-w-md">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
